import MyIcon from '@/components/MyIcon';
import { Image } from 'antd';
import { useState } from 'react';
import PreviewImg from '@/components/Web/PreviewImg';
const Img = ({ src }) => {
    const downloadImg = (e) => {
        e.stopPropagation();
        window.open(src);
    };
    return (
        <div className="img-block">
            <span onClick={downloadImg} className="img-download">
                <MyIcon type="icon-xiazai" />
            </span>
            <PreviewImg src={src} className="ai-img" />
            {/* <img className="ai-img" src={src} /> */}
            {/* <Image
                style={{
                    display: 'none'
                }}
                preview={{
                    visible,
                    src,
                    onVisibleChange: (value) => {
                        setVisible(value);
                    }
                }}
            ></Image> */}
        </div>
    );
};

export default Img;
